import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MUploadPageComponent } from './upload-page.component';

@NgModule({
  imports: [CommonModule],
  declarations: [MUploadPageComponent],
  exports: [MUploadPageComponent]
})
export class MUploadPageModule {}
